export const LANG_DEFAULT = "th";
export const LANGUAGES = [
  {
    id: "th",
    title: "Thai",
    label: "Thai",
    locale: "th",
    code: "TH",
    image: "/assets/images/languages/language-3@2x.png",
    icon: "/assets/images/languages/language-3.png",
    icon_srcset:
      "/assets/images/languages/language-3.png 1x, images/languages/language-3@2x.png 2x",
    default: true,
  },
  {
    id: "en",
    title: "English",
    label: "English",
    locale: "en",
    code: "EN",
    image: "/assets/images/languages/language-1.png",
    icon: "/assets/images/languages/language-1.png",
    icon_srcset:
      "/assets/images/languages/language-1.png 1x, images/languages/language-1@2x.png 2x",
  },
];
export const LANGS = LANGUAGES.map((item) => item.locale);
